import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, Printer } from "lucide-react";
import logo from "@/assets/logo.png";

const Footer = () => (
  <footer className="bg-card border-t border-border">
    <div className="max-w-[1400px] mx-auto section-padding pb-10">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-3 mb-6">
            <img src={logo} alt="NewSilkWay" className="h-14 mix-blend-screen" width={63} height={56} loading="lazy" />
          </div>
          <p className="text-sm text-muted-foreground leading-relaxed">
            GATEWAY TO ECONOMIC GROWTH IN CENTRAL ASIA
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-sm font-display font-semibold text-foreground uppercase tracking-wider mb-6">Quick Links</h4>
          <div className="space-y-3">
            {[
              { label: "About New Silkway", path: "/about/nsi" },
              { label: "SEZ Concept", path: "/sez/concept" },
              { label: "Investment Opportunities", path: "/sez/investment" },
              { label: "Locations", path: "/locations" },
              { label: "News", path: "/news" },
            ].map((link) => (
              <Link key={link.path} to={link.path} className="block text-sm text-muted-foreground hover:text-primary transition-colors">
                {link.label}
              </Link>
            ))}
          </div>
        </div>

        {/* Development */}
        <div>
          <h4 className="text-sm font-display font-semibold text-foreground uppercase tracking-wider mb-6">Development</h4>
          <div className="space-y-3">
            {[
              { label: "Inland Dry Port", path: "/development/dry-port" },
              { label: "Financial Center", path: "/development/financial-center" },
              { label: "Manufacturing Park", path: "/development/manufacturing" },
              { label: "Sustainable Energy", path: "/development/energy" },
              { label: "Medical & Research", path: "/development/medical" },
            ].map((link) => (
              <Link key={link.path} to={link.path} className="block text-sm text-muted-foreground hover:text-primary transition-colors">
                {link.label}
              </Link>
            ))}
          </div>
        </div>

        {/* Contact */}
        <div>
          <h4 className="text-sm font-display font-semibold text-foreground uppercase tracking-wider mb-6">Contact</h4>
          <div className="space-y-4">
            <div className="flex items-start gap-3">
              <MapPin className="w-4 h-4 text-primary mt-0.5 shrink-0" />
              <div className="text-sm text-muted-foreground whitespace-nowrap">
                <div>Yaesu Chuo Bldg. 4F</div>
                <div>2-8-1 Kyobashi, Chuo-ku</div>
                <div>Tokyo, Japan 104-0031</div>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <MapPin className="w-4 h-4 text-primary mt-0.5 shrink-0" />
              <div className="text-sm text-muted-foreground whitespace-nowrap">
                <div>Shakhrisabz Proezd 6</div>
                <div>Mirabad District</div>
                <div>Tashkent, Uzbekistan 100060</div>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Mail className="w-4 h-4 text-primary mt-0.5 shrink-0" />
              <span className="text-sm text-muted-foreground">info@nsicorp.jp</span>
            </div>
            <div className="flex items-start gap-3">
              <Phone className="w-4 h-4 text-primary mt-0.5 shrink-0" />
              <span className="text-sm text-muted-foreground">+81 3-6262-3076</span>
            </div>
            <div className="flex items-start gap-3">
              <Printer className="w-4 h-4 text-primary mt-0.5 shrink-0" />
              <span className="text-sm text-muted-foreground">+81 3-6263-0568</span>
            </div>
          </div>
        </div>
      </div>

      <div className="pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-xs text-muted-foreground">© 2026 New Silkway Special Economic Zone. All rights reserved.</p>
        <div className="flex gap-6">
          <span className="text-xs text-muted-foreground hover:text-primary transition-colors cursor-pointer">Privacy Policy</span>
          <span className="text-xs text-muted-foreground hover:text-primary transition-colors cursor-pointer">Terms of Service</span>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
